import axios from "axios";

import Cookies from "js-cookie";
import { QueryClient, QueryClientConfig } from "react-query";
import config from "./config.api";

const api = axios.create(config);

export const rqueryclient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
} as QueryClientConfig);

// Função para configurar e atualizar o token
export function provideToken(token: string): void {
  if (!token) return;

  // Atualiza o token nos cookies e na instância do Axios
  Cookies.remove("@access");
  Cookies.set("@access", token, { expires: 30 });

  // Invalida queries (caso esteja usando React Query)
  if (rqueryclient) rqueryclient.invalidateQueries();
}

// Interceptor de resposta para atualizar o token
api.interceptors.response.use(
  (response) => {
    //alert("response got ")
    const newToken = response.headers["x-access-token"];
    if (newToken) {
      console.log("A new token was provided!", newToken);
      provideToken(newToken);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 498) {
      localStorage.removeItem("hasOldCustomerId");
      localStorage.removeItem("student");
      Cookies.remove("@access");
      // Redireciona para a página de sessão expirada
      location.href = "/expired";
    }
    return Promise.reject(error);
  },
);

api.interceptors.request.use(
  (config) => {
    const access = Cookies.get("@access");
    if (access) config.headers.Authorization = `Bearer ${access}`;
    else delete config.headers.Authorization;

    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

export default api;
